import 'resize-observer-polyfill';
import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';

import { withBaseContainer } from '../BaseContainer';
import BCLLoading from '../common/Loading/BCLLoading';
import ErrorMain from '../common/Error/ErrorMain';
import MarketplaceContainer from '../dashboard/Marketplace/MarketplaceContainer';
import RecoDetailsPageMain from '../dashboard/recoDetailsPage/RecoDetailsPageMain';

import { WIDGET_PATHS, WIDGET_BASE_PATH } from '../../constants/paths';
import { PRODUCT_TYPE } from '../../constants/common';

const PreferencesContent = React.lazy(() => import(/* webpackChunkName: "PreferencesContent" */ '../standalone/Preferences/PreferenceContent/PreferencesContent'));
let isPublic = false;
const Widget = (props) => {
  isPublic = props.isPublic;
  return (
    <div className="widget-container">
      <React.Suspense fallback={<BCLLoading />}>
        <Switch>
          <Redirect exact from={WIDGET_BASE_PATH} to={WIDGET_PATHS.PREFERENCES} />
          <Route path={WIDGET_PATHS.PREFERENCES} render={() => <PreferencesContent routePath={WIDGET_PATHS.PREFERENCES} />} />
          <Route exact path={WIDGET_PATHS.MARKETPLACE} render={() => <MarketplaceContainer isPublic={isPublic} />}></Route>
          <Route exact path={WIDGET_PATHS.RECO_DETAILS} render={() => <RecoDetailsPageMain isPublic={isPublic} {...props}/>}></Route>
          <Route component={ErrorMain} />
        </Switch>
      </React.Suspense>
    </div>
  )
}

export default withBaseContainer(Widget, PRODUCT_TYPE.WEB, isPublic);
